<template>
  <div class="dialogMember">
    <el-dialog
      :visible.sync="dialog.visible"
      :show-close=false
      :before-close="handleClose">
      <div class="title">邀请成员</div>
      <split></split>
      <div class="form_body">
        <el-form ref="link_form" label-width="0">
          <el-form-item class="invite_link">
            <el-input
              v-model="link"
              placeholder="邀请链接">
            </el-input>
          </el-form-item>
          <split></split>
          <div class="form_buttons">
            <el-button class="cancel_btn" @click.stop="closeMemberDialog">跳过</el-button>
            <el-button class="confirm_btn" type="primary"
                       v-clipboard:copy="link"
                       v-clipboard:success="onCopy"
                       v-clipboard:error="onError">复制链接</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
   <!-- <div class="cover"></div>
    <div class="dialog">
      <div class="title">添加日程</div>
      <div class="content"></div>
    </div>-->
  </div>
</template>

<script type="text/ecmascript-6">
import split from './split_line_2px.vue'
import { mapState } from 'vuex'
export default {
  name: 'dialogMember',
  components: {
    split
  },
  props: {
    dialogMemberVisible: false
  },
  data: function () {
    return {
      team_name: '',
      team_no: '',
      dialog: {
        visible: false,
        method: '',
        no: ''
      }
    }
  },
  methods: {
    handleClose () {
      console.log('handle dialog close')
    },
    closeMemberDialog () {
      let data = {
        visible: false,
        team_name: '',
        team_no: ''
      }
      this.$store.dispatch('setMemberDialog', data)
    },
    onCopy: function (e) {
      this.$message({
        message: '复制成功',
        center: true,
        type: 'success'
      })
    },
    onError: function (e) {
      this.$message({
        message: '复制失败',
        center: true,
        type: 'error'
      })
    }
  },
  computed: {
    ...mapState([
      'memberDialog'
    ]),
    // link () { return 'http://localhost:9192/pc_index.html?#/addTeamMember?creator_name=' + this.$store.state.userInfo.username + '&creator_no=' + this.$store.state.userInfo.user_no + '&team_name=' + this.team_name + '&team_no=' + this.team_no }
    link () { return 'http://weitik.com/#/addTeamMember?creator_name=' + this.$store.state.userInfo.username + '&creator_no=' + this.$store.state.userInfo.user_no + '&team_name=' + this.team_name + '&team_no=' + this.team_no }
  },
  watch: {
    memberDialog: {
      handler (newVal, oldVal) {
        this.dialog.visible = newVal.visible
        this.team_name = newVal.team_name
        this.team_no = newVal.team_no
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  // .addSchedule
  //   .cover
  //     position fixed
  //     top 0
  //     left 0
  //     width 100%
  //     height 100%
  //     background rgba(0, 0, 0, 0.7)
  //     z-index 30
  //   .dialog
  //     position fixed
  //     top: 10%
  //     left 35%
  //     width 33.75rem
  //     height 40.625rem
  //     z-index 50
  //     border-radius 0.125rem
  //     box-shadow 0 0.0625rem 0.1875rem $tinGrey
  //     background $white
  .dialogMember
    .el-dialog
      width 23.625rem
      .el-dialog__header
        display none
      .el-dialog__body
        padding 0 1.25rem 1rem 1.25rem
        .title
          height 3.4375rem
          line-height 3.4375rem
          text-align center
          font-size 1.125rem
          font-weight 500
        .form_body
          .form_buttons
            text-align right
            margin 1rem 0 0 0
            .el-button--medium
              padding 6px 11px
              font-size 16px
              i
                margin-left 5px
                font-size 16px
            .cancel_btn
              border none
              outline none
              background transparent
          .el-form-item.type_form_item
            margin-bottom 1rem
          .el-form-item
            margin-bottom 0
            .el-form-item__content
              display flex
              .label_icon
                flex 1
                font-size 1rem
                font-weight 900
                color $lightGrey
              .date_picker,.sub_title,.el-select,.el-input
                flex 7
                input
                  height 2.5rem
                  width 100%
                  padding 0
                  border none
              .sub_title_2
                flex 13
              .takeplace
                flex 6
              .el-textarea
                textarea
                  height 9.0625rem
                  padding 0.31256rem
                  border none
                  outline none
                  resize none
              .el-input__prefix,.el-input__suffix
                display none
              .el-radio-button
                margin-right 2rem
                .el-radio-button__inner
                  width 1.875rem
                  height 1.875rem
                  padding 0
                  border-radius 50%
                  outline none
                  font-size 0.625rem
                  line-height 1.875rem
                  text-align center

</style>



// WEBPACK FOOTER //
// src/pagesPc/others/dialogMember.vue